<template>
    <div>
        <div class="banner">
            <div class="headerReplacementDebtInfo"></div>
            <div class="banner-text">
                <b>{{ $t('creditRating.title') }}</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">{{ $t('creditRating.breadcrumb.home') }}</router-link></span>
                    <span class="separator"></span>
                    <span>{{ $t('creditRating.breadcrumb.section') }}</span>
                    <span class="separator"></span>
                    <span><b>{{ $t('creditRating.breadcrumb.current') }}</b></span>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="TabMenu">
                <DebtInfoTabMenu />
            </div>

            <table class="table mt-3 mb-5">
                <thead>
                    <tr class="table-secondary text-center">
                        <th scope="col"><b>{{ $t('creditRating.table.date') }}</b></th>
                        <th scope="col"><b>{{ $t('creditRating.table.rating') }}</b></th>
                        <th scope="col"><b>{{ $t('creditRating.table.download') }}</b></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                        <td class="text-center">{{ formatDate(item.rating_date) }}</td>
                        <td class="text-center">{{ item.credit_rating }}</td>
                        <td class="text-center">
                            <a :href="item.pdf_url" target="_blank">
                                <i class="text-secondary fa-solid fa-download"></i>
                            </a>
                        </td>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>
</template>
  
<script>
import DebtInfoTabMenu from '@/components/DebtInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_CREDIT_RATINGS_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        DebtInfoTabMenu,
    },
    data() {
        return {
            list: [],
        };
    },
    async created() {
        this.isLoading = true;
        await this.init();
        this.isLoading = false;
    },
    watch: {
        '$i18n.locale'(newLang) {
            this.init();
        }
    },
    methods: {
        async init() {
            const lang = this.$i18n.locale || 'th';
            this.list = await store.dispatch(GET_CREDIT_RATINGS_DATA, lang);
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            const day = date.getDate();
            const lang = this.$i18n.locale;

            const months = {
                th: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                en: ['January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December']
            };

            const month = months[lang]?.[date.getMonth()] || months['th'][date.getMonth()];
            const year = lang === 'th' ? date.getFullYear() + 543 : date.getFullYear();

            return `${day} ${month} ${year}`;
        }
    }


};
</script>
<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
  